import { List, Popconfirm } from 'antd';
import { Button } from 'components/ui';
import { mapIpToMachineName } from 'containers/Performance/EnochPerf/common';
import { useRunEnochJob, useTerminateEnochJob } from 'mutation/enoch';
import { useGetIdleEnochVMs, useGetRunningEnochVMs } from 'query/enoch';
import React from 'react';

const RunEnoch = () => {
  const { data: listOfIdleVMs } = useGetIdleEnochVMs();

  const { data: listOfRunningVMs } = useGetRunningEnochVMs();

  const { mutate: terminateAutomation } = useTerminateEnochJob();

  const { mutate: runAutomation } = useRunEnochJob();

  const canRunAutomation = listOfIdleVMs?.length;

  const canTerminateAutomation = listOfRunningVMs?.length;

  return (
    <div style={{ display: 'flex', marginBottom: 10 }}>
      <Popconfirm
        disabled={!canRunAutomation}
        okText="Run Automation"
        title={<ListAffectedVMs list={listOfIdleVMs} />}
        onConfirm={() => runAutomation({ ipAddress: 'ALL' })}
      >
        <Button disabled={!canRunAutomation}>
          Start All VMs {canRunAutomation ? `(${listOfIdleVMs.length})` : ''}
        </Button>
      </Popconfirm>

      <Popconfirm
        disabled={!canTerminateAutomation}
        okText="Terminate Automation"
        title={<ListAffectedVMs list={listOfRunningVMs} />}
        onConfirm={() => terminateAutomation({ ipAddress: 'ALL' })}
      >
        <Button disabled={!canTerminateAutomation}>
          Terminate All VMs{' '}
          {canTerminateAutomation ? `(${listOfRunningVMs.length})` : ''}
        </Button>
      </Popconfirm>
    </div>
  );
};

const ListAffectedVMs = ({ list }) => {
  return (
    <div>
      You are about to start automation on the following vms
      <div style={{ marginTop: 10 }}>
        <List
          dataSource={list.map(v => mapIpToMachineName[v] || v)}
          pagination={{ pageSize: 5 }}
          renderItem={item => <List.Item>{item}</List.Item>}
          size="small"
        />
      </div>
    </div>
  );
};

export default RunEnoch;
